module.exports = __webpack_public_path__ + "img/arrow-left-thin.9306400a.svg";